import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	agentsCanAdd: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-can-add',
		defaultMessage: 'Yes, agents can add announcements to this portal',
		description: 'Option in "Can agents add announcements to this service project portal?"',
	},
	onlyAdminsCanAddJsm: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.only-admins-can-add-jsm',
		defaultMessage: 'No, only project administrators can add announcements to this portal',
		description: 'Option in "Can agents add announcements to this service project portal?"',
	},
	canAgentsAddAnnouncementsJsm: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.can-agents-add-announcements-jsm',
		defaultMessage: 'Can agents add announcements to this portal?',
		description: 'Question above radio on JSM project settings page for Customer portal settings',
	},
	helpCentreAnnouncement: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.help-centre-announcement',
		defaultMessage: 'Help center announcement',
		description: 'Header on the JSM project settings page for Customer portal settings',
	},
	jsdConfigLink: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.jsd-config-link',
		defaultMessage: 'You can change this setting on the {configLink}.',
		description: 'Link to edit whether agents can change help center announcements',
	},
	agentsCanChange: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-can-change',
		defaultMessage: 'Agents can change the help center announcement.',
		description: 'Text under help center announcement on customer portal settings page',
	},
	agentsCanChangeMultiHc: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-can-change-multi-hc',
		defaultMessage:
			'Agents can add announcements to help centers on this site. Jira admins can change this setting on the <a>Jira Service Management configuration page</a>.',
		description: 'Text under help center announcement on customer portal settings page',
	},
	agentsCanChangeFindMoreMultiHc: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-can-change-find-more-multi-hc',
		defaultMessage:
			'Help center announcements will be displayed on the home page and is unique to each help center. <a>Find out how to add an announcement to a help center</a>.',
		description:
			'Text under help center announcement on customer portal settings page with find more link',
	},
	agentsCanChangeNotAdmin: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-can-change-not-admin',
		defaultMessage: 'Agents can add announcements to the help center.',
		description: 'Text under help center announcement on customer portal settings page',
	},
	agentsCannotChange: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-cannot-change',
		defaultMessage:
			'Your Jira admin has not allowed agents to change the help center announcement.',
		description: 'Text under help center announcement on customer portal settings page',
	},
	agentsCannotChangeMultiHc: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-cannot-change-multi-hc',
		defaultMessage:
			'Agents cannot add announcements to help centers on this site. Jira admins can change this setting on the <a>Jira Service Management configuration page</a>.',
		description: 'Text under help center announcement on customer portal settings page',
	},
	agentsCannotChangeNotAdmin: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.agents-cannot-change-not-admin',
		defaultMessage:
			'Your Jira admin has not allowed agents to add announcements to the help center.',
		description: 'Text under help center announcement on customer portal settings page',
	},
	jiraServiceManagementConfigurationPage: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.jira-service-management-configuration-page',
		defaultMessage: 'Jira Service Management configuration page',
		description: 'link to the Jira Service Management configuration page',
	},
	save: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.save',
		defaultMessage: 'Save',
		description: 'Save button that saves the radio field in customer portal settings',
	},
	errorFailed: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.error-failed',
		defaultMessage: "We couldn't change your announcement permissions. Please try again.",
		description: 'Error shown if submitting fails',
	},
	managePortalAnnouncements: {
		id: 'servicedesk-settings-customer-portal-v2.customer-portal-forms.portal-announcements.manage-portal-announcements',
		defaultMessage: 'Manage portal announcements',
		description: 'Text for manage portal announcements on Customer Portal Settings',
	},
});
